module.exports = __webpack_public_path__ + "img/title+@3x.f5169a55.png";